import module from 'cheques/module.js'
import template from './template.html'
import moment from 'moment'

const estados = [
  {value: '0', descripcion: 'Todos'},
  {value: 't', descripcion: 'Tránsito'},
  {value: 'r', descripcion: 'Retenido'},
  {value: 'x', descripcion: 'Cancelado'},
  {value: 'c', descripcion: 'Cobrado'},
]

export class ChequesListadoComponent {
  busqueda
  cuentasBancarias = []
  catalogos = {}

  constructor (ChequesEmpresas, $location, $filter, $catalogos, $q, $state) {
    this.ChequesEmpresas = ChequesEmpresas
    this.$location = $location
    this.$catalogos = $catalogos
    this.$q = $q
    this.$state = $state
    this.estados = estados
    this.filterBy = $filter('filter')
  }

  $onInit () {
    this.$promise = this.$q.all([
      this.$catalogos.get('cuentasBancarias')
        .then((data) => (this.cuentasBancarias = data)),
      this.ChequesEmpresas.get()
        .then((response) => (this.empresas = response.data)),
    ])
      .then(() => (this.filtarCuentas()))
  }

  $onChanges (changes) {
    if (changes.busqueda)
      this.busqueda = {
        empresa: this.busqueda.idempresa || undefined,
        cuentabancaria: this.busqueda.cuenta || undefined,
        fechaInicial: this.busqueda.fechaInicial || moment().subtract(1, 'week').toDate(),
        fechaFinal: this.busqueda.fechaFinal || new Date(),
        estado: this.busqueda.estado || 't',
      }
  }

  buscar () {
    this.$location.search({
      idempresa: this.busqueda.empresa,
      cuenta: this.busqueda.cuentabancaria,
      fechaInicial: this.busqueda.fechaInicial.toYMD(),
      fechaFinal: this.busqueda.fechaFinal.toYMD(),
      estado: this.busqueda.estado,
    })
  }

  filtarCuentas () {
    if (this.busqueda.empresa) {
      this.catalogos.cuentasbancarias = this.cuentasBancarias.filter((item) => item.ID_Cliente === this.busqueda.empresa)
    }
  }

  toAgregar () {
    this.$state.go('^.agregar')
  }
}

module.component('chequesListado', {
  controller: ChequesListadoComponent,
  template,
  bindings: {
    busqueda: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cheques/components/listado/component.js